<ng-template [ngIf]="sezioneEconomica">
  <div class="row container_fieldset">
    <div class="col-sm-12 col-xs-12">
      <fieldset class="form-group">
        <legend>Spese di giudizio</legend>
        <form *ngIf= "speseForm" [formGroup]="speseForm">
          <div class="row">
            <div comboModInput class="col-sm-4" [control]="speseForm.controls['descrizioneSpesa']"
            [labelInput]="'Descrizione spesa'"
            [autocomplete]="true" [location]="'plus'"
            [(ngModel)]="spesa.descrizioneSpesa"
            formControlName="descrizioneSpesa"
            [optionsCombo] ="descrizioniSpese"
            [mandatory]="true"
            [objectReference]="spesa.descrizioneSpesa"
            (onReturn)="spesa.descrizioneSpesa = $event;"
            (recordToAdd)="addRecord($event)"></div>
            <div textInputCurrency class="col-sm-4"
            [labelInput]="'Valore'" formControlName="valoreSpesa"
            [location]="'SezioneEconomica'"
            [control]="speseForm.controls['valoreSpesa']"
            [(ngModel)]="spesa.valoreSpesa" [mandatory]="true"></div>
            <div class="col-sm-3" style="margin-top: 20px;">
              <p>
                <button type="button" [disabled]="!speseForm.valid" class="btn btn-primary btn-block" (click)="addSpesaGiudizio();">{{isModifica ? 'Modifica' : 'Aggiungi'}}</button>
              </p>
            </div>
          </div>
        </form>
        <div class="row" style="padding: 10px;">
          <table class="table-striped table aggiunta_classificazione">
            <caption class="sr-only">Tabella spese</caption>
            <tr>
              <th style="width: 40%;">
                Descrizione spesa
              </th>
              <th style="width: 30%">
                Valore
              </th>
              <th style="width: 50%">Opzioni</th>
            </tr>
            <tr *ngFor="let spesaEl of spese; let i = index">
              <td>{{spesaEl.descrizioneSpesa.label}}</td>
              <td>{{spesaEl.valoreSpesa | euro}}</td>
              <td>
                <div class="row">
                  <div class="col-sm-6"><a [title]="isModifica &&  spesa.id === spesaEl.id ? 'Annulla modifica' : 'Modifica'" id="pencil{{i}}" href="javascript:void(0);"  [ngStyle]="{'color': isModifica  && spesa.id === spesaEl.id ? 'red' : '' }" (click)="modificaSpesa(spesaEl)"><span
                  [ngClass]="['glyphicon', isModifica && spesa.id === spesaEl.id ? ' glyphicon-remove' : 'glyphicon-pencil']"></span>
                    </a></div>
                  <!--<div  *ngIf="isModifica" class="col-sm-6"><a style="color: red" id="remove{{i}}" href="javascript:void(0);" (click)="closeModifica()"><span
                      class="glyphicon glyphicon-remove"></span>
                    </a></div>-->
                  <div class="col-sm-6"> <a title="Elimina" id="trash{{i}}" [ngClass]="isModifica && i === index ? 'link-grey' : ''" href="javascript:void(0);" (click)="deleteSpesa(spesaEl);"><span
                        class="glyphicon glyphicon-trash"></span></a></div>
                </div>
              </td>
            </tr>
            <tr class="selected_second_level" *ngIf="spese && spese.length > 0">
              <td><strong>Totale spese</strong></td>
              <td><strong>{{totale() | euro}}</strong></td>
              <td></td>
            </tr>
          </table>
        </div>
      </fieldset>
    </div>
  </div>
</ng-template>
